import {combineReducers} from "@reduxjs/toolkit";
import confirm from "./confirm/reducer";

export default combineReducers({
    confirm
})